module.exports = __webpack_public_path__ + "static/media/about-page__logo.af6b911b.png";